import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import FormSelect from '../inputFields/FormSelect'
import FormInput from '../inputFields/FormInput'
import FormattedInput from '../inputFields/FormattedInput'
import MaskedInput from '../inputFields/MaskedInput'
import { formatPostalCode } from '../../util/strings'
import { Divider, FlexColumn, FormRow } from '../styles/Containers'
import { formSection, formWording } from '../styles/FormStyleConfig'
import { InfoMessage } from '../common/UserMessage'
import { provinces } from '../../util/consts'

function ContactForm({ format = 'default', perspective = 'requestor', disabled = false }) {
  const { getValues } = useFormContext()
  const [defaultProvince, setDefaultProvince] = useState()

  useEffect(() => {
    setDefaultProvince(getValues('requestor.province') || '')
  }, [])

  const TitleComponent = formSection[format].font.formTitle
  const basis = formSection[format].muiTextField.basis
  const capitalizedPronoun = formWording[perspective].pronoun.charAt(0).toUpperCase() + formWording[perspective].pronoun.slice(1)

  return (
    <FlexColumn gap={formSection[format].gap.div}>
      <TitleComponent>{formWording[perspective].possessive} Contact Information</TitleComponent>
      {formSection[format].divider && <Divider />}
      <InfoMessage>
        {capitalizedPronoun} must provide either an email address or mailing address for us to contact {formWording[perspective].objectPronoun}.
      </InfoMessage>
      <FormRow gap={formSection[format].gap.row}>
        <MaskedInput id="requestor.phone" label="Phone" format="(###) ###-####" textFieldFormat={format} basis={basis} disabled={disabled} />
        <FormInput id="requestor.email" label="Email" textFieldFormat={format} basis={basis} disabled={disabled} />
        <FormInput id="requestor.confirmEmail" label="Confirm Email" textFieldFormat={format} basis={basis} disabled={disabled} />
      </FormRow>
      <FormRow gap={formSection[format].gap.row}>
        <FormInput id="requestor.address" label="Address" textFieldFormat={format} basis={basis} disabled={disabled} />
        <FormInput id="requestor.unit" label="Unit" textFieldFormat={format} basis={basis} disabled={disabled} />
        <FormInput id="requestor.city" label="City" textFieldFormat={format} basis={basis} disabled={disabled} />
        {defaultProvince !== undefined && (
          <FormSelect
            id="requestor.province"
            label="Province"
            options={provinces}
            defaultValue={defaultProvince}
            textFieldFormat={format}
            basis={basis}
            disabled={disabled}
          />
        )}
        <FormattedInput
          id="requestor.postalCode"
          label="Postal Code"
          handleFormatValue={formatPostalCode}
          textFieldFormat={format}
          basis={basis}
          disabled={disabled}
        />
      </FormRow>
    </FlexColumn>
  )
}

ContactForm.propTypes = {
  format: PropTypes.oneOf(['default', 'condensed']),
  perspective: PropTypes.oneOf(['requestor', 'staff']),
  disabled: PropTypes.bool
}

export default ContactForm
